import { createContext } from "react";

export const SoundContext = createContext(null);

export const VibrationContext = createContext(null);